import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"

export default function SelectedFilters() {
    const { filters } = useProductFilters()

    return (filters.length > 0 && (
        <div class="ns-active-filters-container ns-flex ns-flex-wrap ns-items-center">
            {filters.map(filter => (
                <button
                aria-label={filter.name + ": " + filter.value + ", Remove filter"}
                    
                    className="ns-active-filter ns-inline-flex ns-items-center ns-justify-center"
                     
                    onClick={() => filter.remove()}
                >
                    <span class="ns-active-filter__title" >{filter.value}</span>
                    <span>
                        <svg class="ns-active-filter__icon" aria-hidden="true" focusable="false" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
                            <path d="M56 5.638l-22.362 22.362 22.362 22.362-5.638 5.638-22.362-22.362-22.362 22.362-5.638-5.638 22.362-22.362-22.362-22.362 5.638-5.638 22.362 22.362 22.362-22.362z"></path>
                        </svg>
                    </span>
                </button>
            ))}
        </div>
    ))
}